import angular from 'angular';
import { RealEstateAgentComponent } from './real-estate-agent.component';
import captchaService from '../../captcha/captcha.module'
const MODULE_NAME = 'RealEstateAgent';

export default angular.module(MODULE_NAME, [captchaService]).component('realEstateAgent', RealEstateAgentComponent).name;


